import Button from "atoms/buttons/button";
import { ButtonSizes } from "atoms/constants/button-sizes";
import { ButtonStyles } from "atoms/constants/button-styles";
import PublicationCodeGroupRecord from "models/view-models/publication-code-group-record";
import PublicationRecord from "models/view-models/publication-record";
import UserPublicationPinRecord from "models/view-models/user-publication-pin-record";
import PublicationItem, {
    PublicationTextStyle,
} from "organisms/publication-lists/publication-item";
import React, { useState } from "react";
import { useLocalization } from "utilities/hooks/use-localization";

const ITEM_BASE_CLASS = "c-publication-selection-list-group-item";

interface PublicationGroupProps {
    publicationGroup: PublicationCodeGroupRecord;
    onPublicationClick: (publication: PublicationRecord) => void;
    pins?: UserPublicationPinRecord[];
    onChangePins: (pins: UserPublicationPinRecord[]) => void;
}

const PublicationGroup = (props: PublicationGroupProps) => {
    const { onPublicationClick, publicationGroup, pins, onChangePins } = props;

    const [showEarlierEditions, setShowEarlierEditions] = useState(false);

    const mostRecentEdition = publicationGroup.publications![0];
    const earlierEditions = publicationGroup.publications!.slice(1);

    const { t } = useLocalization();

    const buttonText = showEarlierEditions
        ? t("hide-earlier-editions")
        : t("show-earlier-editions");
    const accessibleText = buttonText;
    const controlId = `earlier-editions-${publicationGroup.code}`;

    const toggleEarlierEditions = (
        e: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
        e.preventDefault();
        e.stopPropagation();
        setShowEarlierEditions(!showEarlierEditions);
    };

    return (
        <>
            <PublicationItem
                onPublicationClick={onPublicationClick}
                pins={pins}
                onChangePins={onChangePins}
                publication={mostRecentEdition}
                style={PublicationTextStyle.TitleFirst}>
                {earlierEditions.length > 0 && (
                    <Button
                        cssClassName={`${ITEM_BASE_CLASS}__showEditions`}
                        accessibleText={accessibleText}
                        ariaControls={controlId}
                        ariaExpanded={showEarlierEditions}
                        onClick={toggleEarlierEditions}
                        style={ButtonStyles.Anchor}
                        size={ButtonSizes.Small}>
                        {buttonText}
                    </Button>
                )}
            </PublicationItem>
            {showEarlierEditions && (
                <div id={controlId}>
                    {earlierEditions.map((publication) => {
                        return (
                            <PublicationItem
                                key={publication.id}
                                isNested={true}
                                onPublicationClick={onPublicationClick}
                                pins={pins}
                                onChangePins={onChangePins}
                                publication={publication}
                                style={PublicationTextStyle.EditionFirst}
                            />
                        );
                    })}
                </div>
            )}
        </>
    );
};

export default PublicationGroup;
